import { useLocation } from 'react-router';

const useLocationState = <T extends object>() => {
  const { state } = useLocation();
  return (state || {}) as T;
};

export default useLocationState;
